// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_si-0";
export var checkoutRateBadgeLink = "_si-1";